import {Component, ViewChild} from '@angular/core';

import {Destroyable} from '../destroyable.component';
import {SdcLogsListComponent} from '../shared/sdconnect/sdc-logs-list/sdc-logs-list.component';

@Component({
  selector: 'gp-sdconnect-admin',
  templateUrl: './sdconnect-admin.component.html',
  styleUrls: ['./sdconnect-admin.component.scss']
})
export class SdconnectAdminComponent extends Destroyable {

  @ViewChild(SdcLogsListComponent) sdcLogListComponent: SdcLogsListComponent;

  constructor() {
    super();
  }
}
